"use client";

import type { ReactNode } from "react";
import ErrorPage from "@/components/sections/errors/ErrorPage";
import { useApiError } from "@/contexts/ApiErrorContext";

interface ApiErrorBoundaryProps {
	children: ReactNode;
}

export default function ApiErrorBoundary({ children }: ApiErrorBoundaryProps) {
	const { hasCriticalError, clearApiError } = useApiError();

	if (hasCriticalError) {
		return <ErrorPage type="500" reset={clearApiError} />;
	}

	return <>{children}</>;
}
